<template>
	<div>
		<v-card-text class="pa-0" style="height: 500px; overflow-y: auto;">
			<v-layout class="pa-2" row wrap style="height: auto;" v-if="group">
				<v-flex xs6 style="padding-bottom: 5px;" pr-1>
					<v-text-field v-model="group.name" label="Name"></v-text-field>
					<multi-select label="Accounts" :items="all_accounts" v-model="group.accounts" item-text="email" item-value="id" allow-empty></multi-select>

					<template v-if="$is_admin()">
						<v-checkbox v-model="group.meta.productions" label="Show productions"></v-checkbox>
						<template v-if="group.meta.productions">
							<template v-for="account in sorted_accounts(group)">
								<v-list dense>
									<v-list-tile>
										<v-list-tile-title>{{account_name(account)}}</v-list-tile-title>
										<v-list-tile-content style="min-width: 50%; max-width: 50%;">
										<v-select style="width: 100%;" :items="production_roles" item-text="title" item-value="role" v-model="group.meta.production_roles[account]"></v-select>
										</v-list-tile-content>
									</v-list-tile>
								</v-list>
							</template>
						</template>
					</template>
				</v-flex>
				<v-flex xs6 style="padding-bottom: 5px;" pr-1>
					<multi-select label="Source channels" :items="source_channels" v-model="input_channels" item-text="title" item-value="uuid" allow-empty></multi-select>
					<multi-select label="Dest channels" :items="dest_channels" v-model="output_channels" item-text="title" item-value="uuid" allow-empty></multi-select>
					<multi-select label="Content lists" :items="content_lists" v-model="group.cms_lists" item-text="name" item-value="id" allow-empty></multi-select>
					<multi-select label="Content list types" :items="content_list_types" v-model="group.cms_list_types" item-text="name" item-value="id" allow-empty></multi-select>
					<multi-select label="Settings" :items="settings" v-model="group.settings" :item-text="(item) => { return '[' + item.type + '] ' + item.name; }" item-value="id" allow-empty></multi-select>
					<!--
					<json-editor v-model="group.meta"></json-editor>
				-->
				</v-flex>

			</v-layout>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="error" v-show="is_edit && group.state != 'archived'" @click="changeState('archived')">Archive</v-btn>
      <v-btn color="error" v-show="is_edit && group.state == 'archived'" @click="changeState('active')">Unarchive</v-btn>
			<v-btn color="success" @click="save(false)">Save</v-btn>
			<v-btn color="success" @click="save(true)">Save and close</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
import MultiSelect from '@/components/MultiSelect'
import Vue from 'vue';

export default {
	props: ["id"],
	components: {
		JsonEditor,
		MultiSelect
	},
	data () {
		var ch = this.$cloudserver.channel("groups:"+(this.id||"create"));
		return {
			ws_channel: ch,
			group: this.convertGroup(ch.data),
			input_channels: [],
			output_channels: [],
			production_roles: [
				{role: "director", title: "Director"},
				{role: "commentator", title: "Commentator"},
				{role: "intercom", title: "Intercom"},
				{role: "control", title: "Control"},
				{role: "producer", title: "Producer"}
			]
			//accounts: []
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				if(typeof(newVal) != "undefined") {
					this.group = this.convertGroup(newVal, oldVal);
					this.input_channels = this.filter_channels(newVal.channels, this.source_channels);
					this.output_channels = this.filter_channels(newVal.channels, this.dest_channels);
				}
			},
			deep: true
		},
		'$route' (to, from) {
			if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
				this.ws_channel = this.$cloudserver.channel("groups:"+(this.id||"create"));
				this.ws_channel.join();
			}
		},
		'group.accounts' (to, from) {
			this.update_production_roles(to);
		}
	},
	created() {
	  this.ws_channel.join();
	},
	computed: {
		is_edit () {
			return typeof(this.group) != "undefined" && this.group.id != null;
		},
		accounts: {
			get () {
				return this.group.accounts;
	  	},
      set (val) {
      	this.group.accounts = val;
      }
		},
		all_accounts () {
			return Object.values(this.$store.state.accounts);
		},
		source_channels () {
			return this.$store.getters.input_channels;
		},
		dest_channels () {
			return this.$store.getters.output_channels;
		},
		content_lists () {
			return Object.values(this.$store.state.cms_lists);
		},
		content_list_types () {
			return Object.values(this.$store.state.cms_list_types);
		},
		settings () {
			return Object.values(this.$store.state.settings);
		}

	},
	methods: {
		sorted_accounts(group) {
			return group.accounts;
		},
		update_production_roles(accounts) {
			var self = this;
			var new_roles = {};
			_.each(accounts, function(account_id) {
				new_roles[account_id] = self.group.meta.production_roles[account_id] || "";
			})
			Vue.set(this.group.meta, "production_roles", new_roles);		
		},
		account_name(account_id) {
			var acc = this.$store.state.accounts[account_id];
			if (typeof(acc) != "undefined") {
				return acc["email"];
			}
			return "";
		},
		filter_channels(channels_list, values) {
			var ids = _.map(values, function(v) {
				return v.uuid;
			});
			return _.filter(channels_list, function(channel_id) {
				return ids.includes(channel_id);
			});
		},
		convertGroup (newVal, oldVal) {
			var group = _.cloneDeep(newVal);
			if(typeof(oldVal) != "undefined") {
				//TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
			}

			if(typeof(group) == "undefined" || _.isEmpty(group)) return undefined;
			if (typeof(group.meta.production_roles) == "undefined") {
				group.meta.production_roles = {};
			}
			return group;
		},
    changeState (state) {
      this.group.state = state;
      this.save(false);
    },
		reset () {
			this.group = this.convertGroup(this.ws_channel.data);
		},
		save (close) {
			var self = this;
      if (typeof(this.ws_channel) != "undefined") {
      	var group = _.cloneDeep(this.group);

      	group.channels = _.uniq(self.input_channels.concat(self.output_channels));

      	// Tässä pitää kasata channels listat yhteen

				this.ws_channel.save({group: group})
					.then((msg) => {
						if (typeof(self.id) == "undefined") {
							self.$message.success("Group was created!");
						} else {
							self.$message.success("Group was updated!");
						}
						if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
					})
					.catch((msg) => {
						console.log(msg);
						if (typeof(self.id) == "undefined") {
							self.$message.warning("Unable to create group!");
						} else {
							self.$message.warning("Unable to update group!");
						}
					});
      }
		}
	}
}
</script>
